import React from 'react';
import { styled } from '@mui/material';
import MuiCard, { CardProps } from '@mui/material/Card';
import MuiCardHeader, { CardHeaderProps } from '@mui/material/CardHeader';
import MuiCardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';

// TODO Consider removing this component

// TODO: use colors from theme
type CustomCardProps = {
  disabled?: boolean;
};

const StyledMuiCardHeader = styled(MuiCardHeader)(({ theme }) => ({
  '& button:not(:last-child)': {
    marginRight: theme.spacing(1),
  },
}));

const StyledMuiCard = styled(MuiCard, {
  shouldForwardProp: (propName: string) => propName !== 'disabled',
})<CustomCardProps>(({ theme, disabled }) => ({
  marginBottom: theme.spacing(3),
  backgroundColor: disabled ? '#F5F5F5' : theme.palette.common.white,
}));

const Card: React.FC<CardProps & CustomCardProps> = (props) => <StyledMuiCard {...props} />;

// TODO: check title type later
const CardHeader: React.FC<{ title: React.ReactNode } & Omit<CardHeaderProps, 'title'>> = (
  props,
) => <StyledMuiCardHeader disableTypography={true} {...props} />;

const StyledCardActions = styled(MuiCardActions)({
  justifyContent: 'space-between',
});

export { Card, CardHeader, StyledCardActions as CardActions, CardContent };
